/** @jsxImportSource @emotion/react */
'use memo'

import { ArrowRightOutlined } from '@ant-design/icons'
import css from '@emotion/css/macro'
import styled from '@emotion/styled'
import type { OrgRegistrationBadge } from '@sportninja/common/features/organization/registration/utils/cardModel'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import Button from 'src/components/ts-components/Button'

interface Props {
  badge: OrgRegistrationBadge
  onOpen: () => void
}

/**
 * The row's action, as on the card: Register Now while open, View Details
 * otherwise — both open the registration page. Compact, to sit in the row,
 * and as wide as the column, so the two labels give every row one button size.
 */
const RegisterCell = ({ badge, onOpen }: Props) => {
  'use memo'

  const isOpen = badge === 'open' || badge === 'closingSoon'

  return (
    <Wrapper>
      <Button
        size='compact'
        variant={isOpen ? 'primary' : 'outlined'}
        text={capitalizeWords(isOpen ? 'Register Now' : 'View Details')}
        icon={<ArrowRightOutlined />}
        iconPosition='end'
        onClick={onOpen}
        style={fillColumnStyle}
      />
    </Wrapper>
  )
}

export default RegisterCell

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`

// Compact buttons size to their label; this one fills the column instead.
const fillColumnStyle = css`
  flex: 1 1 auto;
  width: 100%;
`
